export const arMenuItemsTranslations = {
	menuItems: {
		// Page titles
		title: 'عناصر القائمة',
		subtitle: 'إدارة وتنظيم عناصر قائمة مطعمك',
		addItem: 'إضافة عنصر',
		editItem: 'تعديل العنصر',

		// Menu item properties
		name: 'اسم العنصر',
		namePlaceholder: 'أدخل اسم العنصر',
		description: 'الوصف',
		descriptionPlaceholder: 'وصف عنصر القائمة...',
		price: 'السعر',
		discountedPrice: 'السعر المخفض',
		image: 'صورة العنصر',
		category: 'الفئة',
		selectCategory: 'اختر فئة',
		status: 'الحالة',

		// Item status and options
		published: 'منشور',
		draft: 'مسودة',
		available: 'متاح',
		unavailable: 'غير متاح',
		featured: 'مميز',

		// Dietary preferences
		vegetarian: 'نباتي',
		vegan: 'نباتي صرف',
		glutenFree: 'خالي من الغلوتين',
		itemSettings: 'إعدادات العنصر',
		dietaryPreferences: 'التفضيلات الغذائية',

		// Actions
		publish: 'نشر',
		unpublish: 'إلغاء النشر',
		feature: 'تمييز',
		unfeature: 'إلغاء التمييز',
		markAvailable: 'تعيين كمتاح',
		markUnavailable: 'تعيين كغير متاح',
		deleteTitle: 'حذف عنصر القائمة',
		// deleteConfirmation: 'هل أنت متأكد من رغبتك في حذف هذا العنصر؟ لا يمكن التراجع عن هذا الإجراء.',

		// View options
		gridView: 'عرض الشبكة',
		listView: 'عرض القائمة',

		// Empty states
		noItems: 'لا توجد عناصر',
		noItemsYet: 'لا توجد عناصر في القائمة حتى الآن',
		createFirstItemDescription: 'ابدأ بإضافة عناصر القائمة لعرضها في قائمة مطعمك',
		noMatchingItems: 'لم يتم العثور على عناصر مطابقة',
		tryAdjustingFilters: 'حاول تعديل البحث أو المرشحات',
		noImage: 'لا توجد صورة',
		noCategories: 'لا توجد فئات متاحة',
		noCategoriesWarning: 'تحتاج إلى إنشاء فئات أولاً',

		// Export
		exportStarted: 'بدأ التصدير. سيتم إشعارك عند الانتهاء.',

		uploadImage: 'انقر لتحميل الصورة',
		updateItem: 'تحديث العنصر',
		noDescription: 'لا يوجد وصف',
		deleting: 'جارٍ الحذف...',
		deleteMessage: 'هل أنت متأكد من رغبتك في حذف هذا العنصر؟ لا يمكن التراجع عن هذا الإجراء.',
		deleteFailed: 'فشل في حذف عنصر القائمة. يرجى المحاولة مرة أخرى.',

		noItemsInCategory: 'لا تحتوي هذه الفئة على أي عناصر حتى الآن',
		addFirstItem: 'إضافة العنصر الأول',
		filteredByCategory: 'مفلتر حسب الفئة',

		basicInformation: 'المعلومات الأساسية',
		additionalDetails: 'التفاصيل الإضافية',
		imageAndSettings: 'الصورة والإعدادات',
		options: 'الخيارات',
		labels: 'التصنيفات',
		addIngredientPlaceholder: 'اكتب اسم المكون واضغط Enter',
		preparationTime: 'وقت التحضير (بالدقائق)',

		// Errors
		errors: {
			nameRequired: 'اسم العنصر مطلوب',
			invalidPrice: 'يرجى إدخال سعر صالح',
			invalidDiscountedPrice: 'يجب أن يكون السعر المخفض أقل من السعر العادي',
			categoryRequired: 'الفئة مطلوبة',
			createFailed: 'فشل في إنشاء عنصر القائمة. يرجى المحاولة مرة أخرى.',
			updateFailed: 'فشل في تحديث عنصر القائمة. يرجى المحاولة مرة أخرى.',

			discountedPriceTooHigh: 'يجب أن يكون السعر المخفض أقل من السعر العادي',
			deleteFailed: 'فشل في حذف عنصر القائمة. يرجى المحاولة مرة أخرى.',

			invalidCalories: 'يرجى إدخال عدد صحيح من السعرات الحرارية',
			invalidPreparationTime: 'يرجى إدخال وقت تحضير صحيح',
			variantOptionNameRequired: 'اسم خيار المتغير {{index}} مطلوب',
			variantChildNameRequired: 'اسم طفل خيار المتغير {{optionIndex}} {{childIndex}} مطلوب',
			variantChildPriceRequired: 'يجب أن يكون سعر طفل خيار المتغير {{optionIndex}} {{childIndex}} رقماً موجباً صالحاً',
			dietaryPreferencesFetchFailed: 'فشل في تحميل التفضيلات الغذائية'
		},

		itemNotFound: 'عنصر القائمة غير موجود',
		itemNotFoundDescription: 'عنصر القائمة الذي تبحث عنه غير موجود أو تمت إزالته.',
		backToMenuItems: 'العودة إلى عناصر القائمة',
		noImageAvailable: 'لا توجد صورة متاحة',
		minutes: 'دقائق',
		pricing: 'التسعير',
		regularPrice: 'السعر العادي',
		quickActions: 'إجراءات سريعة',
		itemDetails: 'تفاصيل العنصر',
		ingredients: 'المكونات',
		dietaryInfo: 'المعلومات الغذائية',
		noDietaryRestrictions: 'لا توجد قيود غذائية خاصة',
		noDietaryPreferences: 'لم يتم تعيين أي تفضيلات غذائية',
		dietaryPreferencesInfo: 'تم وضع علامة على هذا العنصر بالتفضيلات الغذائية الموضحة أعلاه.',
		calories: 'السعرات الحرارية',
		cal: 'سعرة',
		spiceLevel: 'مستوى الحرارة',
		spice: {
			none: 'غير حار',
			mild: 'خفيف',
			medium: 'متوسط',
			hot: 'حار',
			extra_hot: 'حار جداً'
		},
		activityStats: 'النشاط والإحصائيات',
		createdAt: 'تاريخ الإنشاء',
		lastUpdated: 'آخر تحديث',
		analyticsComingSoon: 'بيانات التحليلات والأداء قادمة قريباً',
		noCategory: 'بدون فئة',
		unknownCategory: 'فئة غير معروفة',

		pricingDetails: 'تفاصيل التسعير',
		dietaryInformation: 'المعلومات الغذائية',
		saveAmount: 'وفر ${{amount}} (خصم {{percentage}}%)',
		yes: 'نعم',
		no: 'لا',
		itemStatistics: 'إحصائيات العنصر',
		itemPerformance: 'أداء العنصر',
		performanceDescription: 'ستتوفر التحليلات والرؤى لهذا العنصر قريباً',

		overview: 'نظرة عامة',
		analytics: 'تحليلات',
		actions: 'إجراءات',
		itemAnalytics: 'تحليلات العنصر',

		avgTime: 'متوسط الوقت',
		perMonth: 'شهرياً',
		clicksOverTime: 'النقرات مع مرور الوقت',
		timeSpentOverTime: 'الوقت المستغرق مع مرور الوقت',
		combinedAnalytics: 'تحليلات مجمعة',
		clicks: 'نقرات',
		timeSpent: 'الوقت المستغرق',
		timeSpentMinutes: 'الوقت المستغرق (دقائق)',
		noAnalyticsData: 'لا توجد بيانات تحليلات',
		noAnalyticsDescription: 'ستظهر بيانات التحليلات هنا بمجرد أن يبدأ العملاء في عرض هذا العنصر.',
		item: 'عنصر',

		// Labels/Tags
		foodLabels: 'تصنيفات الطعام',
		foodLabelsDescription: 'اختر التصنيفات التي تصف هذا العنصر لمساعدة العملاء في العثور على ما يبحثون عنه',
		selectedLabels: 'التصنيفات المختارة',
		clearAllLabels: 'مسح الكل',
		selectHealthyLabels: 'اختيار صحي',
		// Settings helpers
		publishedHelper: 'العنصر مرئي للعملاء',
		draftHelper: 'العنصر محفوظ كمسودة وغير مرئي للعملاء',
		availableHelper: 'العنصر متاح للطلب',
		unavailableHelper: 'العنصر غير متاح مؤقتاً',
		featuredHelper: 'سيتم تمييز العنصر كمميز',
		notFeaturedHelper: 'سيظهر العنصر بشكل طبيعي في القائمة',

		// Preview
		itemPreview: 'معاينة العنصر',
		itemName: 'اسم العنصر',
		itemDescription: 'وصف العنصر',

		// Nutrition and Preparation
		nutritionAndPreparation: 'التغذية والتحضير',
		nutritionalInfo: 'المعلومات الغذائية',
		nutritionalInfoDescription: 'إضافة التفاصيل الغذائية تساعد العملاء على اتخاذ خيارات مدروسة حول وجباتهم.',
		englishIngredients: 'المكونات بالإنجليزية',
		arabicIngredients: 'المكونات بالعربية',
		addArIngredientPlaceholder: 'اكتب اسم المكون بالعربية واضغط Enter',
		enIngredientNote: "ملاحظة: يمكنك إدخال مكون واحد أو قائمة مكونات مفصولة بـ ';'",
		arIngredientNote: "ملاحظة: يمكنك إدخال مكون واحد أو قائمة مكونات مفصولة بـ '؛' (Shift + P)",

		// Empty states
		noIngredientsYet: 'لم يتم إضافة مكونات حتى الآن',
		ingredientsWillAppearHere: 'ستظهر المكونات ومجموعات المكونات هنا عند إضافتها إلى عنصر القائمة هذا.',

		// Actions
		clearAllIngredients: 'مسح جميع المكونات',
		addCommonIngredients: 'إضافة مكونات شائعة',
		autoLabeling: 'تسمية تلقائية',

		// Ingredient Management
		ingredientManagement: 'إدارة المكونات',
		individualIngredients: 'المكونات الفردية',
		ingredientGroups: 'مجموعات المكونات',
		ingredient: 'مكون',
		group: 'مجموعة',
		groups: 'مجموعات',
		noIngredientsInGroup: 'لا توجد مكونات في هذه المجموعة',
		ingredientsAndGroups: 'المكونات والمجموعات',
		addIngredientsOrGroups: 'إضافة مكونات فردية أو مجموعات مكونات لهذا العنصر',
		addIngredientsOrGroupsButton: 'إضافة مكونات أو مجموعات',
		searchIngredients: 'البحث في المكونات...',
		searchGroups: 'البحث في المجموعات...',
		noAvailableIngredients: 'لا توجد مكونات متاحة للإضافة',
		noAvailableGroups: 'لا توجد مجموعات متاحة للإضافة',
		noIngredientsFound: 'لم يتم العثور على مكونات مطابقة',
		noGroupsFound: 'لم يتم العثور على مجموعات مطابقة',

		// Basic Information Tab
		englishInformation: 'المعلومات بالإنجليزية',
		arabicInformation: 'المعلومات بالعربية',
		arabicName: 'الاسم بالعربية',
		arabicDescription: 'الوصف بالعربية',
		arabicNamePlaceholder: 'أدخل اسم العنصر بالعربية',
		arabicDescriptionPlaceholder: 'وصف عنصر القائمة بالعربية...',

		// Cross-Selling
		crossSelling: 'البيع المتقاطع',
		crossSellingDescription: 'اختر حتى 3 عناصر للتوصية عند إضافة هذا العنصر',
		suggestedItems: 'العناصر المقترحة',
		noSuggestedItems: 'لم يتم اختيار عناصر مقترحة',
		addSuggestedItems: 'إضافة عناصر مقترحة',
		searchItems: 'البحث عن عناصر...',
		searchToAdd: 'ابحث لإضافة عناصر...',
		selectedCount: '{{count}}/3 محدد',
		maxReached: 'الحد الأقصى 3 عناصر',
		noSelectedItems: 'لم يتم اختيار عناصر. ابحث أعلاه للإضافة.',
		crossSellingSaved: 'تم حفظ التوصيات',
		crossSellingSaveFailed: 'فشل في حفظ التوصيات',
		removeFromManual: 'إزالة من التوصيات اليدوية',
	}
};
